import { render, staticRenderFns } from "./expand-collapse-variant.vue?vue&type=template&id=801ea938&scoped=true"
import script from "./expand-collapse-variant.vue?vue&type=script&lang=js"
export * from "./expand-collapse-variant.vue?vue&type=script&lang=js"
import style0 from "./expand-collapse-variant.vue?vue&type=style&index=0&id=801ea938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801ea938",
  null
  
)

export default component.exports